import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import ProductrawtorawdemandFilterCriteria from './ProductrawtorawdemandFilterCriteria'
import ProductrawtorawdemandList from './ProductrawtorawdemandList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './ProductrawtorawdemandAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setProductrawtorawdemandDashboardProductrawtorawdemandList } from '../../store/slice/PharmaSlice';

export default function ProductrawtorawdemandListView({setShowEdit,setProductrawtorawdemandId}){
    const {filterCriteria} = useSelector((state)=>state.pharmaslice.productrawtorawdemandDashboard);   

    const [filteredProductrawtorawdemandList, setFilteredProductrawtorawdemandList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { productrawtorawdemandDashboard } = useSelector((state) => state.pharmaslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (productrawtorawdemandDashboard.productrawtorawdemandList.length>-1){
        setFilteredProductrawtorawdemandList(productrawtorawdemandDashboard.productrawtorawdemandList);
        transformToCardFormat(productrawtorawdemandDashboard.productrawtorawdemandList, setCardList);
      }
    },[productrawtorawdemandDashboard.productrawtorawdemandList])

    useEffect(()=>{
          transformToCardFormat(filteredProductrawtorawdemandList, setCardList);
      },[filteredProductrawtorawdemandList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.productrawid==='' && filterCriteria.rawdemandid==='' ){
            setFilteredProductrawtorawdemandList(productrawtorawdemandDashboard.productrawtorawdemandList);
            transformToCardFormat(productrawtorawdemandDashboard.productrawtorawdemandList, setCardList);

        } else {
            setFilteredProductrawtorawdemandList(
                productrawtorawdemandDashboard.productrawtorawdemandList
                    .filter(productrawtorawdemand=> productrawtorawdemand.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(productrawtorawdemandDashboard.filteredProductrawtorawdemandList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <ProductrawtorawdemandList
                    setShowEdit={setShowEdit}
                    setProductrawtorawdemandId = {setProductrawtorawdemandId}
                    tableList={filteredProductrawtorawdemandList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}